import { render } from "./FilterDesktop.vue?vue&type=template&id=23b0f451&scoped=true"
import script from "./FilterDesktop.vue?vue&type=script&lang=js"
export * from "./FilterDesktop.vue?vue&type=script&lang=js"

import "./FilterDesktop.vue?vue&type=style&index=0&id=23b0f451&scoped=true&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b0f451"]])

export default __exports__